export function createLogger(scope) {
  const tag = `[${scope}]`

  return {
    warn: (...args) => console.warn(tag, ...args),
    error: (...args) => console.error(tag, ...args)
  }
}
